import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createRestoreReleaseCommand } from '../../../api/commands/factory/createReleaseCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RestoreRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RestoreRelease';

    public constructor(public id: string, public shouldSendCommand: boolean = true) {
        super(RestoreRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RestoreRelease): Promise<boolean> => {
    if (!action.shouldSendCommand) {
        return true;
    }

    const release = state.releases.find((x) => x.id === action.id);
    return await useSendCommandAsync(action, {
        createCommand: async () => await createRestoreReleaseCommand(state.id, release.id, release.name),
    });
};

const reducer = (state: StorymapState, action: RestoreRelease): void => {
    const release = state.releases.find((x) => x.id === action.id);

    release.isArchived = false;
};

//@ts-ignore
registerMiddleware(RestoreRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RestoreRelease.ACTION_TYPE, reducer);
